import { Settings } from 'luxon';

export type LuxonConfig = {
	locale: string;
};

const DEFAULT_CONF: LuxonConfig = {
	locale: 'fr'
};

export function updateLuxonConfiguration(config: LuxonConfig = DEFAULT_CONF) {
	const conf = { ...DEFAULT_CONF, ...config };

	// use en-UK date format for english locale
	Settings.defaultLocale = conf?.locale == 'en' ? 'en-UK' : conf?.locale;
}
